export default __webpack_public_path__ + "static/media/error.8f1b9d80.png";